import { isProductionEnv } from '../config/env';

/** Demo login and demo account UI are never available in production builds. */
export function isDemoAuthEnabled(): boolean {
  if (import.meta.env.PROD) return false;
  if (isProductionEnv()) return false;
  return true;
}
